import PropTypes from 'prop-types';
import { useAppDispatch } from '../../../App/redux/store';
import { comparativeStudyComparisonsActions } from '../../../store/comparativeStudyComparisons/actions';

const ComparisonsTab = ({
  property,
  label,
  comparisonsResume,
  comparisonsActiveTab,
}) => {
  const dispatch = useAppDispatch();

  return (
    <div
      className={`comparative-studies-details-tab ${
        comparisonsActiveTab === property ? 'active' : ''
      }`}
      onClick={() =>
        dispatch(
          comparativeStudyComparisonsActions.setComparisonsActiveTab.set(property),
        )
      }
    >
      <span className="comparative-studies-details-tab-amount">
        {comparisonsResume[property]}
      </span>
      <span className="comparative-studies-details-tab-type">{label}</span>
    </div>
  );
};

ComparisonsTab.propTypes = {
  property: PropTypes.string,
  label: PropTypes.string,
  comparisonsResume: PropTypes.object,
  comparisonsActiveTab: PropTypes.string,
};

export default ComparisonsTab;
